import * as yup from 'yup';

export const formSchema = yup.object({
    price: yup.mixed().required(),
    subject: yup.string().required(),
});